import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=fc129eda"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"
import style0 from "./AddPage.vue?vue&type=style&index=0&id=fc129eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports